import AgreementType from './agreement-type.enum';

export default class AgreementLimit {
  id: string;

  agreementType: AgreementType;

  leader: boolean; // true = Cargos de Liderança, false = Colaboradores (RN-12)

  duczSyndicateFreePercentage: number;

  duczFoodMinimumValue: number;

  duczFoodMaximumValue: number;

  duczFreeMinimumValue: number;

  benefitsSumPercentage: number;

  totalReadjustmentPercentage: number;

  constructor(obj: any = {}) {
    this.id = obj.id || null;
    this.agreementType = obj.agreementType;
    this.leader = !!obj.leader;
    this.duczSyndicateFreePercentage = obj.duczSyndicateFreePercentage;
    this.duczFoodMinimumValue = obj.duczFoodMinimumValue;
    this.duczFoodMaximumValue = obj.duczFoodMaximumValue;
    this.duczFreeMinimumValue = obj.duczFreeMinimumValue;
    this.benefitsSumPercentage = obj.benefitsSumPercentage;
    this.totalReadjustmentPercentage = obj.totalReadjustmentPercentage;
  }

  public static of(apiObj: any): AgreementLimit {
    const obj = apiObj || {};
    return new AgreementLimit({
      id: obj.id,
      agreementType: obj.agreementType,
      leader: obj.leader,
      duczSyndicateFreePercentage: obj.duczSyndicateFreePercent,
      duczFoodMinimumValue: obj.duczFoodMinimumValue,
      duczFoodMaximumValue: obj.duczFoodMaximumValue,
      duczFreeMinimumValue: obj.duczFreeMinimumValue,
      benefitsSumPercentage: obj.benefitSumPercent,
      totalReadjustmentPercentage: obj.totalReadjustmentPercent,
    });
  }

  public static ofList(list: any[]): AgreementLimit[] {
    return (list || []).map(AgreementLimit.of);
  }

  public clone(): AgreementLimit {
    return new AgreementLimit({
      id: this.id,
      agreementType: this.agreementType,
      leader: this.leader,
      duczSyndicateFreePercentage: this.duczSyndicateFreePercentage,
      duczFoodMinimumValue: this.duczFoodMinimumValue,
      duczFoodMaximumValue: this.duczFoodMaximumValue,
      duczFreeMinimumValue: this.duczFreeMinimumValue,
      benefitsSumPercentage: this.benefitsSumPercentage,
      totalReadjustmentPercentage: this.totalReadjustmentPercentage,
    });
  }

  public toPayload() {
    return {
      id: this.id,
      agreementType: this.agreementType,
      leader: this.leader,
      duczSyndicateFreePercent: this.duczSyndicateFreePercentage,
      duczFoodMinimumValue: this.duczFoodMinimumValue,
      duczFoodMaximumValue: this.duczFoodMaximumValue,
      duczFreeMinimumValue: this.duczFreeMinimumValue,
      benefitSumPercent: this.benefitsSumPercentage,
      totalReadjustmentPercent: this.totalReadjustmentPercentage,
    };
  }

  public toDisplayPercentage(value: number): string {
    if (value === null || value === undefined) return '';
    return `${value.toLocaleString('pt-br', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}%`;
  }

  public toDisplayCurrency(value: number): string {
    if (value === null || value === undefined) return '';
    return `R$ ${value.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
}
